<template>
  <v-card flat class="mt-4">    
    <v-form ref="form" :lazy-validation="true">
      <v-row>
        <v-col>
          <v-card-text v-for="c in sortedComments" :key="get(c, 'id', '')">
            <template v-if="get(c, 'data', null)">
              <div class="overline">{{ c.createdAt | date }} {{ c.createdAt | time}}</div>
              <p class="body-1 mb-3 font-italic">{{ get(c, 'data', null) }}</p>
            </template>
            
            <template v-else>
              <div class="overline">{{ c.createdAt | date }} {{ c.createdAt | time}}</div>
              <p class="body-1 mb-3 font-italic">Beställningen skapades.</p>
              <div class="overline">{{ c.createdAt | date }} {{ c.createdAt | time}}</div>
              <h6>{{ get(c, 'createdBy.firstName', '') }} {{ get(c, 'createdBy.lastName', '') }} <span v-if="c.regionName">({{ get(c, 'regionName', '') }}) </span></h6>
              <p class="body-1">{{ c.content }}</p>
            </template>
          </v-card-text>         
        </v-col>
      </v-row>

      <v-card-actions class="buttons" v-if="showCreateButton">        
        <v-btn color="secondary" @click="openDialog" :disabled="!canCreate">
          <v-icon>mdi-comment-text-outline</v-icon>Lägg till kommentar
        </v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="dialog" max-width="600px">
      <OrderAddComment :openDialog="dialog" @close="dialog=false" @save="save"></OrderAddComment>
    </v-dialog>
  </v-card>
</template>


<script>
import {mapGetters} from 'vuex'
import OrderAddComment from '@/components/order/OrderAddComment'
import {RulesMixin, CanIDo} from '@/components/mixins'
import get from 'lodash/get'
import API from '@/services/api.js'
import orderBy from 'lodash/orderBy'
import flatMap from 'lodash/flatMap'

// @group Order
// OrderComments component
export default {
  name: 'OrderComments',

  mixins: [RulesMixin, CanIDo],

  components: {
    OrderAddComment
  },
  props: {
    showCreateButton: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    'selectedOrder.comments': {
      handler: function () {
        this.com = this.selectedOrder.comments.concat(this.personComments)
      },
      deep: true
    }
  },

  data: () => ({
    orderDatatable: [],
    dialog: false,
    com: []
  }),
  
  computed: {
    ...mapGetters('currentuser', ['currentUser']),
    ...mapGetters('order', ['selectedOrder']),

    sortedComments() {
      return orderBy(this.com, ['createdAt'], ['desc'])
    }
  },

  asyncComputed: {
    canCreate(){
      return this.canIDo('admin', 'list');
    },
  },

  created() {
    this.com = this.selectedOrder.comments ? this.selectedOrder.comments : []

    let notes = []

    if(get(this, 'selectedOrder.print.person.notes', []).length)
      notes = [ ...notes, ...get(this, 'selectedOrder.print.person.notes', []) ]

    if ( get(this, 'selectedOrder.student.notes', []).length )
      notes = [ ...notes, ...get(this, 'selectedOrder.student.notes', []) ]

    if ( get(this, 'selectedOrder.application.notes', []).length )
      notes = [ ...notes, ...get(this, 'selectedOrder.application.notes', []) ]

    if ( get(this, 'selectedOrder.print.person.educations', []).length ) {
      const educations = get(this, 'selectedOrder.print.person.educations', [])
      const applicationNotes = flatMap(educations.map(e => get(e, 'application.notes', [])))
      notes = [ ...notes, ...applicationNotes ]
    }

    this.com = [ ...this.selectedOrder.comments, ...notes ]
  },

  methods: {
    get, 

    updateAddress(newAddress) {
      this.apprenticeaddress = newAddress
    },

    openDialog() {
      this.dialog = true
    },
   /**
     * @vuese
     * Used to add comment
     */
    save(comment) {
      //- Add comment
      API.addComment({data: {
        commentableId: this.selectedOrder.id,
        commentableType: 'DistanceOrder',
        content: comment,
        createdById: this.currentUser.id
      }})
      .then(res=>{
        this.$events.fire('showInfo', 'Sparad.')
        this.dialog = false
        // Fire updated event
        // @arg The argument is boolean true-false
        this.$emit('updated')
      })
      .catch(error=>{
        this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
      })
    }
  }
}
</script>

<style lang="scss">
.section {
  div.body-1 {
    padding-bottom: 6px;
  }
}
.buttons {
  button {
    min-width: 200px !important;
    margin-right: 10px !important;

    i {
      padding-right: 5px;
    }
  }
}
</style>
